import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ConversationalAssistant } from './ConversationalAssistant';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
interface AssistantModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const AssistantModal = ({
  isOpen,
  onClose
}: AssistantModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className={
          // Desktop : panneau centré 500px (centrage via translate de Radix, OK).
          "w-[calc(100%-1rem)] h-[calc(100dvh-2rem)] max-w-[min(94vw,500px)] max-h-[calc(100dvh-2rem)] sm:h-[min(660px,calc(100dvh-2rem))] p-0 [&>button]:hidden overflow-hidden flex flex-col z-[9999] rounded-2xl shadow-2xl border-black/5 " +
          // Mobile (<768px) : on N'utilise PAS le centrage par transform ni
          // l'animation d'entrée — sur iOS Safari, le plafond d'animation mobile
          // (* { animation-duration:.15s!important }) cassait le translate(-50%)
          // et la modale débordait à droite/en bas. On ancre en plein écran via
          // inset (aucune dépendance au transform).
          "max-md:!inset-2 max-md:!w-auto max-md:!h-auto max-md:!max-w-none max-md:!max-h-none max-md:!translate-x-0 max-md:!translate-y-0 max-md:!animate-none"
        }
      >
        <VisuallyHidden>
          <DialogTitle>Assistant virtuel</DialogTitle>
        </VisuallyHidden>
        <ConversationalAssistant onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};